import type { ReactNode } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { cn } from '../../lib/cn'

/**
 * Раздел администратора. Отдельного «режима» нет: у кого есть право, тот видит
 * дополнительный пункт в меню — так решено в сценариях.
 */
export function AdminLayout() {
  return (
    <div>
      <nav aria-label="Разделы управления" className="mb-6 flex flex-wrap gap-1 border-b border-line pb-3">
        <AdminTab to="/admin/rooms">Переговорные</AdminTab>
        <AdminTab to="/admin/policies">Правила</AdminTab>
        <AdminTab to="/admin/users">Сотрудники</AdminTab>
      </nav>
      <Outlet />
    </div>
  )
}

function AdminTab({ to, children }: { to: string; children: ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cn(
          'rounded-lg px-3 py-1.5 text-sm font-medium transition',
          isActive ? 'bg-accent-soft text-accent' : 'text-muted hover:text-fg',
        )
      }
    >
      {children}
    </NavLink>
  )
}
